import { render, staticRenderFns } from "./MedicalRecordDetail.vue?vue&type=template&id=6bc72971&scoped=true"
import script from "./MedicalRecordDetail.vue?vue&type=script&lang=js"
export * from "./MedicalRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./MedicalRecordDetail.vue?vue&type=style&index=0&id=6bc72971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc72971",
  null
  
)

export default component.exports